<template>
  <DashboardPanel
    panel-id="v-pills-profile-viewers"
    aria-labelledby="v-pills-profile-viewers-tab"
    title="Profile viewers"
    :subtitle="!loading && viewers.length ? `${viewers.length} employer${viewers.length === 1 ? '' : 's'} viewed your profile` : 'Employers who recently viewed your profile'"
  >
    <div v-if="loading">
      <div class="hc-viewer-skeleton" v-for="n in 3" :key="n">
        <div class="gradient" style="width:48px;height:48px;border-radius:50%;"></div>
        <div style="flex:1;">
          <div class="gradient" style="height:14px;width:160px;margin-bottom:8px;"></div>
          <div class="gradient" style="height:12px;width:100px;"></div>
        </div>
      </div>
    </div>

    <div v-else-if="viewers.length">
      <div class="hc-viewer-card" v-for="(viewer, index) in viewers" :key="index">
        <div class="hc-viewer-card__avatar" aria-hidden="true">
          <i class="mdi mdi-office-building"></i>
        </div>
        <div class="hc-viewer-card__content">
          <strong>{{ formatViewerName(viewer) }}</strong>
          <span>Viewed your profile</span>
        </div>
      </div>
    </div>

    <div v-else class="hc-panel__empty">
      <i class="mdi mdi-eye-off-outline hc-panel__empty-icon" aria-hidden="true"></i>
      <h3>No profile views yet</h3>
      <p>Complete your visume, apply to matching jobs, and keep your profile updated to attract employer attention.</p>
      <ul class="hc-panel__empty-tips">
        <li><i class="mdi mdi-check-circle-outline"></i> Upload a 2-minute visume</li>
        <li><i class="mdi mdi-check-circle-outline"></i> Apply to recommended jobs</li>
        <li><i class="mdi mdi-check-circle-outline"></i> Reach 80% profile completion</li>
      </ul>
    </div>
  </DashboardPanel>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import DashboardPanel from './Dashboard/DashboardPanel.vue';
import '../assets/hire.css';

export default {
  name: 'ProfileViewers',
  components: { DashboardPanel },
  data() {
    return {
      action: new Actions(),
      viewers: [],
      loading: true,
    };
  },
  beforeMount() {
    this.loadViewers();
  },
  methods: {
    loadViewers() {
      const token = this.$cookies.get('hire-seeker')?.token;
      if (!token) {
        this.loading = false;
        return;
      }
      this.action.getProfileViews(token).then((res) => {
        if (res.status) {
          this.viewers = res.views || [];
        }
      }).catch(() => {
        this.viewers = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    formatViewerName(viewer) {
      if (typeof viewer === 'string') return viewer;
      return viewer?.company_name || viewer?.name || viewer?.employer_name || 'Employer';
    },
  },
};
</script>
